import React from "react";

/*
 * Text inputs per DESIGN.md §4: 48px, 16/24, radius 24, padding 12/16.
 * Light: white bg, #E5E7EB border, blue focus ring.
 * Dark: transparent bg, #A3A3A3 placeholder, Sky Blue focus ring.
 * Error: #E41D1D border + red ring + 12px message.
 */

export function TextInput({ dark = false, error = false, className = "", ...rest }) {
  const theme = dark
    ? "bg-transparent text-ic-offwhite placeholder:text-[#A3A3A3] focus:border-ic-sky focus:shadow-ic-focus-dark-soft"
    : "bg-white text-ic-navy placeholder:text-ic-placeholder focus:border-ic-blue focus:shadow-ic-focus-soft";
  const errorClasses = error ? "border-ic-error shadow-ic-error-ring" : "border-ic-lightGray";
  return (
    <input
      className={
        `font-sans text-[16px] leading-6 font-normal px-4 h-12 w-full box-border border rounded-3xl ` +
        `transition-all duration-150 ease-out focus:outline-none ` +
        `disabled:bg-ic-disabledBg disabled:text-ic-borderGray disabled:border-ic-lightGray disabled:cursor-not-allowed ` +
        `${theme} ${errorClasses} ${className}`
      }
      {...rest}
    />
  );
}

export function Field({ label, htmlFor, required = false, error, dark = false, className = "", children }) {
  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label
          htmlFor={htmlFor}
          className={`text-[14px] leading-5 font-medium mb-2 ${dark ? "text-ic-lightGray" : "text-ic-body"}`}
        >
          {label}
          {required && <span className="text-ic-error"> *</span>}
        </label>
      )}
      {children}
      {error && <span className="text-[12px] leading-4 font-normal text-ic-error mt-1">{error}</span>}
    </div>
  );
}

/*
 * Checkbox with a 44px hit area wrapping the 20px visual box (showcase §05).
 */
export function Checkbox({ checked, onChange, label, id, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <button
        type="button"
        role="checkbox"
        aria-checked={checked}
        aria-label={typeof label === "string" ? label : undefined}
        id={id}
        onClick={() => onChange(!checked)}
        className="w-11 h-11 inline-flex items-center justify-center bg-transparent border-0 p-0 cursor-pointer focus-visible:outline-none focus-visible:shadow-ic-focus-soft rounded-xl"
      >
        {checked ? (
          <span className="w-5 h-5 rounded box-border border-2 border-ic-blue bg-ic-blue inline-flex items-center justify-center">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M2 6.5L4.5 9L10 3" />
            </svg>
          </span>
        ) : (
          <span className="w-5 h-5 rounded box-border border-2 border-ic-borderGray bg-white inline-block" />
        )}
      </button>
      {label && (
        <span onClick={() => onChange(!checked)} className="text-[16px] leading-6 text-ic-body cursor-pointer">
          {label}
        </span>
      )}
    </div>
  );
}
